module.exports = __webpack_public_path__ + "img/视光无界.0ce7d3d1.png";